// Documentación de la liberia https://teodosii.github.io/react-notifications-component/
// Ejemplos de notificaciones y L&F https://www.npmjs.com/package/react-notifications-component

import { store } from 'react-notifications-component';

export const message = (title, message) => {

    store.addNotification({
        title: title,
        message: message,
        type: "default",
        insert: "top",
        container: "top-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
}

export const messageError = (title, message) => {

    store.addNotification({
        title: title,
        message: message,
        type: "danger",
        insert: "top",
        container: "top-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
}
